import { render, staticRenderFns } from "./WorkPdfDocument.vue?vue&type=template&id=e4b923ca"
import script from "./WorkPdfDocument.vue?vue&type=script&lang=js"
export * from "./WorkPdfDocument.vue?vue&type=script&lang=js"
import style0 from "./WorkPdfDocument.vue?vue&type=style&index=0&id=e4b923ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports